import React, { useState, memo } from 'react';
import axios from 'axios';
import Modal from './UI/Modal/Modal';
import { useSelector, useDispatch } from 'react-redux';
import { useProductPics } from '../hooks/useProductPics';
import { define, tokenExpiredMsg, expNotifyDuration } from '../data/globals'
import { useNotify } from '../hooks/useNotify';


const Products = (props) => {
    // Redux
    const updProdId = useSelector(state => state.updProd.id)
    const dispath = useDispatch()
    
    const [idToDelete, setIdToDelete] = useState(0)
    const [modalProdName, setModalProdName] = useState('')
    const [delModal, setDelModal] = useState(false)
    const getProductPics = useProductPics()
    const { pushNotify } = useNotify()


    function selectProduct(id, name, description, price) {
        // Поля выбранного продукта (из массива products)
        dispath({
            type: 'SetUpdProd',
            id: id,
            name: name,
            description: description,
            price: Number(price).toFixed(2),
        })

        // Получение списка изображений (по id товара)
        getProductPics(id)
    }

    function confirmDelete(id, name) {
        setIdToDelete(id)
        setModalProdName('Вы действительно хотите удалить<br>товар <b>' + name + '</b>?')
        setDelModal(true)
    }

    // Скрываем модальное окно
    function hideModal() {
        setDelModal(false)
    }
    // ########################################################
    // Добавить удаление изображений связаных с товаром
    // Здесь на фронте или на бэке. Скорее всего лучше на бэке
    // ########################################################

    // Удаление подтверждено. Удаляем товар
    async function deleteProduct() {

        try {
            const response = await axios({
                method: 'post',
                url: define.pathToAPI + '/products/delete.php',
                data: JSON.stringify({
                    id: idToDelete,
                    userToken: localStorage.getItem('AuthToken'),
                }),
            })// axios

            // console.log('response: ', response);

            // проверка ответа от delete.php
            switch(response.data.message){
                case 'Товар удалён':
                    props.deleteProdsData( idToDelete )
                    setDelModal( false )
                    break
                case 'Токен устарел!':
                    pushNotify(tokenExpiredMsg, "notifyWelcome", expNotifyDuration)
                    // props.pushNotify(tokenExpiredMsg, "notifyWelcome", expNotifyDuration)
                    // ########################################################
                    // При блокировке доступа, удалить картинки, которые не были сохранены в базе
                    // ########################################################
                    break
                case 'Токены не совпадают! Доступ запрещен':
                    pushNotify("Токены не совпадают! Alarm! Доступ запрещен", "notifyWelcome")
                    // props.pushNotify("Токены не совпадают! Alarm! Доступ запрещен", "notifyWelcome")
                    // ########################################################
                    // При блокировке доступа, удалить картинки, которые не были сохранены в базе
                    // ########################################################
                    break
                default:
                    console.log('Ошибка при удалении товара.\nСервер отвечает (код 200). Но нет подтверждения от delete.php, что товар удален')
                    alert('Ошибка при удалении товара (см.  консоль)')
                    break
            } // switch

        } catch (e) {
            if(e === 'AxiosError: Request failed with status code 400') {
                console.log('Ошибка при удалении товара\nКод: 400 - Некорректный ID\n(см. update.php)')
                alert('Ошибка (код: 400) при удалении товара (см.  консоль)')
            } else {
                console.log('Ошибка при удалении товара\n' + e)
                alert('Ошибка при удалении товара\n' + e)
            }
        }// try
    }
    
    return (
        <>
            <Modal
                visible={delModal}
                modalColors="modalOrange"
                header="Удаление"
                pic='alert'
                message={modalProdName}
                btn1Text="Да"
                btn2Text="Нет"
                сonfirmed={deleteProduct}
                hide={hideModal}
            />
            {(props.products.length === 0) &&
            <div className='prodItem pl-30'>(пусто)</div> }
            {props.products.map((prod) =>
                <div key={prod.id}
                    className={`prodItem pl-30 ${prod.id === updProdId ? "current" : ''}`}
                    onClick={() => selectProduct(prod.id, prod.name, prod.description, prod.price, prod.categoryId, prod.categoryName)}
                    >
                    <img src={ define.pathToGraphics + '/document_16px.png' } className='ml-4 mr-6' alt=''/>
                    <div className="grow1">
                        { prod.name }
                        {/* [{ prod.id }] */}
                        {/* { prod.name } / { prod.description } [{ prod.id }] */}
                    </div>
                    <div>
                    <div
                        className='catBtn'
                        onClick={(e) => {
                            e.stopPropagation();
                            confirmDelete(prod.id, prod.name)} }
                        ><img src={ define.pathToGraphics + '/delete_16px.png' } alt=''/></div>
                    </div>
                </div>
            )}
        </>
    )
}

export default memo(Products)